import React from "react";
import { getSrc } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import ImageTransform from "../common/ggfx-client/module/components/image-transform";
import NoImage from "../images/no-image.png"
import GGFXTransform from "../common/stb-jamstack-ggfxclient/module/components/ggfx-transform";

const ImageModule = (props) => {

    const { site } = useStaticQuery(
        graphql`
          query {
            site {
              siteMetadata {
                title
                description
                author
              }
            }
          }
        `
    )

    const defaultTitle = site.siteMetadata?.title

    if(props.ImageSrc && props.ImageSrc.url){

        var image_url = props.ImageSrc.url;
        if(props.ImageSrc.url_sharp){
            image_url = getSrc(props.ImageSrc.url_sharp)
        }

        //console.log("image_url", image_url)

        let alt_text = props.ImageSrc.alternativeText ? props.ImageSrc.alternativeText : props.altText;

    
        return (
            <>
                {props.imagename ? (
                    // <ImageTransform imagesources={props.ImageSrc.url} renderer={props.renderer} imagename={props.imagename} attr={{className:props.classNames, alt: alt_text+" - "+process.env.GATSBY_SITE_NAME }} imagetransformresult={props.imagetransforms} id={props.strapi_id} />

                    <GGFXTransform 
                        mediaUrl={props.ImageSrc.url} 
                        renderer={props.renderer} 
                        transformConfigName={props.imagename} 
                        preResult={props?.ggfx_results} 
                        id={props.strapi_id} 
                        attr={{...props.attr, className:props.classNames, alt: alt_text+" - "+defaultTitle}}
                    />
                    
                ) : (
                    <img src={props.ImageSrc.url} alt={alt_text+" - "+defaultTitle} className={props.className || props.classNames} width={props?.width} height={props?.height}  />
                )
                }
            </>
            
        )
    } else{ 
        return (
            <img src={NoImage} alt="img" {...props} className={props.classNames}/>
        )
    }
    
}
export default ImageModule;